import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect, useRef } from 'react';
import { ShieldCheck } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import userApi from '../../services/api/userApi';
const ModalBoasVindas = () => {
    const { user, isAuthenticated, hasPermission, updateUser } = useAuth();
    const [visivel, setVisivel] = useState(false);
    const [confirmando, setConfirmando] = useState(false);
    // Guard: once confirmed this session, never re-show regardless of state re-hydration
    const confirmedRef = useRef(false);
    useEffect(() => {
        if (confirmedRef.current)
            return;
        if (isAuthenticated &&
            user &&
            hasPermission('geral', 'visualizar_aviso_boas_vindas') &&
            !user.aviso_boas_vindas_confirmado_em) {
            setVisivel(true);
        }
        else {
            setVisivel(false);
        }
    }, [isAuthenticated, user, hasPermission]);
    if (!visivel)
        return null;
    const handleConfirmar = async () => {
        if (confirmando)
            return;
        setConfirmando(true);
        confirmedRef.current = true;
        try {
            await userApi.confirmarAvisoBoasVindas();
            updateUser({
                ...user,
                aviso_boas_vindas_confirmado_em: new Date().toISOString(),
            });
            setVisivel(false);
        }
        catch {
            // Falha silenciosa — tentará novamente no próximo login
            setVisivel(false);
        }
        finally {
            setConfirmando(false);
        }
    };
    return (_jsxs("div", { className: "fixed inset-0 z-[9999] overflow-y-auto", children: [_jsx("div", { className: "fixed inset-0 bg-black/60" }), _jsx("div", { className: "flex min-h-full items-center justify-center p-4", children: _jsxs("div", { className: "relative bg-white dark:bg-gray-800 rounded-lg shadow-xl w-full max-w-lg", children: [_jsxs("div", { className: "flex items-center gap-3 p-6 border-b border-gray-200 dark:border-gray-700", children: [_jsx(ShieldCheck, { className: "h-6 w-6 text-icavi-600 shrink-0" }), _jsx("h3", { className: "text-lg font-semibold text-gray-900 dark:text-gray-100", children: "Bem-vindo(a) ao Portal Icavi!" })] }), _jsxs("div", { className: "p-6 space-y-4 text-sm text-gray-700 dark:text-gray-300 leading-relaxed", children: [_jsx("p", { children: "Para garantir a seguran\u00E7a das informa\u00E7\u00F5es, a integridade dos processos e a aplica\u00E7\u00E3o de boas pr\u00E1ticas, a Icavi realiza o monitoramento do uso deste sistema, incluindo o registro das atividades realizadas na plataforma." }), _jsxs("p", { children: ["Esse monitoramento \u00E9 feito em conformidade com a", ' ', _jsx("strong", { className: "text-gray-900 dark:text-gray-100", children: "LGPD" }), " e com as pol\u00EDticas internas de seguran\u00E7a da informa\u00E7\u00E3o da empresa."] }), _jsxs("p", { children: ["Em caso de d\u00FAvidas, entre em contato com a equipe do", ' ', _jsx("strong", { className: "text-gray-900 dark:text-gray-100", children: "Departamento Pessoal" }), "."] })] }), _jsx("div", { className: "flex justify-end p-6 border-t border-gray-200 dark:border-gray-700", children: _jsx("button", { type: "button", onClick: handleConfirmar, disabled: confirmando, className: "inline-flex items-center gap-2 px-5 py-2.5 bg-icavi-600 hover:bg-icavi-700 disabled:opacity-60 text-white text-sm font-medium rounded-lg transition-colors", children: confirmando ? 'Confirmando...' : 'Confirmar e Continuar' }) })] }) })] }));
};
export default ModalBoasVindas;
